// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
  var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
  // var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});
// ヘッダーの固定エフェクト // Fixed header effect

jQuery(function ($) {
  $(window).on("load", function () {
    const headNav = $("header");
    if ($(".top_view").length) {
      var fvHeight = $(".top_view").height();
    } else {
      var fvHeight = 30;
    }
    console.log(fvHeight);
    $(window).scroll(function () {
      if ($(this).scrollTop() > fvHeight && headNav.hasClass("fixed") == false) {
        //headerの高さ分上に設定（上から下りてくる動きにするため）
        headNav.css({ top: "-100px" });
        //クラスfixedを付与
        headNav.addClass("fixed");
        //位置を0に設定し、上から下りてくるスピードを設定
        headNav.animate({ top: 0 }, 500);
      } else if ($(this).scrollTop() < fvHeight && headNav.hasClass("fixed") == true) {
        // クラスfixedを外す
        headNav.removeClass("fixed");
      }
    });
  });
});

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function ($) {
  if ($(".obj_image").length > 0) {
    objectFitImages(".obj_image");
  }
});

// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
  if ($("dl.accordion dt").length > 0) {
    $("dl.accordion dt").click(function () {
      $(this).next("dd").slideToggle();
      $(this).toggleClass("open");
    });
  }
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用 // For links within an area
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

jQuery(function ($) {
  if ($(window).width() < 767) {
    $(".js-select").on("click", ".draw", function () {
      $(this).closest(".js-select").children("li:not(.draw)").toggle();
    });

    var allOptions = $(".js-select").children("li:not(.draw)");
    $(".js-select").on("click", "li:not(.draw)", function () {
      allOptions.removeClass("selected");
      $(this).addClass("selected");
      $(".js-select").children(".draw").html($(this).html());
      allOptions.toggle();
    });

    $(document).click(function (e) {
      var content = $(".js-select");
      if (!content.is(e.target) && content.has(e.target).length === 0) {
        content.find("li").not(".draw").hide();
      }
    });
  }
});

//tab
jQuery(function ($) {
  $(".tab-pane.active").show();
  $(".tablinks").on("click", function () {
    const tabId = $(this).data("tab");
    $(".tab-pane").hide();
    $(`#${tabId}`).show();
    $(".tablinks").removeClass("active");
    $(this).addClass("active");
  });
});

//Modal
jQuery(function ($) {
  MicroModal.init({
    awaitOpenAnimation: true, // モーダルオープン時にアニメーションを許可
    awaitCloseAnimation: true, // モーダルクローズ時にアニメーションを許可
    disableScroll: true, // bodyのスクロールを禁止
    disableFocus: true, // モーダルオープン時にモーダル内要素にフォーカスさせない

    onShow: (modal) => {
      const $modal = $(modal);
      const id = $modal.find(".js_youtube_player").data("id");

      // モーダル表示後に少し待ってから再生（描画完了を待つ）
      setTimeout(() => {
        if (players[id] && typeof players[id].playVideo === "function") {
          // 自動再生制限対策（必要に応じて）
          // players[id].mute();
          players[id].playVideo();
        }
      }, 300); // 遅延タイミングは環境により調整
    },

    onClose: (modal) => {
      const $modal = $(modal);
      const id = $modal.find(".js_youtube_player").data("id");

      if (players[id] && typeof players[id].pauseVideo === "function") {
        players[id].pauseVideo();
      }
    },
  });
});

//沿革
jQuery(function ($) {
  // liの数を取得
  const listItems = $(".history-box").length;
  $(".about-history-content").each(function () {
    // 最初に表示させるliの数
    let num = 4,
      // 閉じた時に表示させるliの数
      closeNum = num - 1;
    // 最初はもっと見るボタン表示、閉じるボタン非表示
    $(this).find(".history-btn").show();
    // 5行目まで表示
    $(this)
      .find(".history-box:not(:lt(" + num + "))")
      .hide();
    // もっと見るボタンがクリックされた時
    $(".history-btn").click(function () {
      // numに+5ずつしていく = 5行ずつ追加する
      num += 5;
      $(this)
        .parent()
        .find(".history-box:lt(" + num + ")")
        .slideDown();
      // liの数よりnumが多い時、
      if (listItems <= num) {
        // もっと見るボタン非表示
        $(".history-btn").hide();
      }
    });
  });
});

// ページトップボタンの表示 // Display the page top button
jQuery(function ($) {
  const pageTop = $("#pageup");
  pageTop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      pageTop.fadeIn();
    } else {
      pageTop.fadeOut();
    }
  });
  pageTop.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });
  // フッター手前でストップ
  $("#pageup").hide();
  $(window).on("scroll", function () {
    scrollHeight = $(document).height();
    scrollPosition = $(window).height() + $(window).scrollTop();
    footHeight = $(".footer-copyright").innerHeight() + 50;
    if (scrollHeight - scrollPosition <= footHeight) {
      // ページトップボタンがフッター手前に来たらpositionとfixedからabsoluteに変更
      $("#pageup").css({
        position: "absolute",
        right: "20px",
        bottom: footHeight,
      });
    } else {
      $("#pageup").css({
        position: "fixed",
        bottom: "20px",
      });
    }
  });
});

jQuery(function ($) {
  var scrollCont = $(".member-box-content");
  scrollCont.scroll(function () {
    var scrollHint = $(this).parent(".member-box").find(".member-box-link");
    if ($(this).scrollLeft() > 50) {
      scrollHint.fadeOut();
    } else {
      scrollHint.fadeIn();
    }
  });
});
